// removed by extract-text-webpack-plugin
module.exports = {"bold":"bold__1a3lLOmEEtgL","create":"create__QThm15dILGcX","spaceLeft":"spaceLeft__P0I0g5sIErvv"};